// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Lo2X","alert":"SettungsInbox_alert__3XlRI"};